import api from './apiClient';
import {
  Appointment,
  AppointmentCreate,
  AppointmentUpdate,
  AppointmentListResponse,
  AvailableTimeSlot,
  AppointmentStats,
  VeterinarianSchedule,
  VeterinarianScheduleCreate,
} from '../types';

export const appointmentService = {
  createAppointment: async (data: AppointmentCreate): Promise<Appointment> => {
    const response = await api.post('/appointments/', data);
    return response.data;
  },

  getAppointments: async (params?: {
    veterinarian_id?: number;
    clinic_id?: number;
    pet_id?: number;
    owner_id?: number;
    status?: string;
    appointment_type?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    size?: number;
  }): Promise<AppointmentListResponse> => {
    const response = await api.get('/appointments/', { params });
    return response.data;
  },

  getAppointment: async (id: number): Promise<Appointment> => {
    const response = await api.get(`/appointments/${id}`);
    return response.data;
  },

  updateAppointment: async (id: number, data: AppointmentUpdate): Promise<Appointment> => {
    const response = await api.put(`/appointments/${id}`, data);
    return response.data;
  },

  cancelAppointment: async (id: number, cancellation_reason: string): Promise<void> => {
    await api.post(`/appointments/${id}/cancel`, { cancellation_reason });
  },

  getAvailableTimeSlots: async (
    veterinarian_id: number,
    appointment_date: string,
    duration_minutes: number = 30,
    clinic_id?: number
  ): Promise<{ available_slots: AvailableTimeSlot[] }> => {
    const response = await api.get(`/appointments/veterinarian/${veterinarian_id}/available-slots`, {
      params: {
        appointment_date,
        duration_minutes,
        clinic_id
      }
    });
    return response.data;
  },

  getAppointmentStats: async (params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<AppointmentStats> => {
    const response = await api.get('/appointments/stats', { params });
    return response.data;
  },

  createVeterinarianSchedule: async (data: VeterinarianScheduleCreate): Promise<VeterinarianSchedule> => {
    const response = await api.post('/appointments/schedules', data);
    return response.data;
  },

  getVeterinarianSchedules: async (veterinarian_id: number): Promise<{ schedules: VeterinarianSchedule[] }> => {
    const response = await api.get(`/appointments/schedules/veterinarian/${veterinarian_id}`);
    return response.data;
  },

  updateVeterinarianSchedule: async (id: number, data: Partial<VeterinarianScheduleCreate>): Promise<VeterinarianSchedule> => {
    const response = await api.put(`/appointments/schedules/${id}`, data);
    return response.data;
  },

  deleteVeterinarianSchedule: async (id: number): Promise<void> => {
    await api.delete(`/appointments/schedules/${id}`);
  },
};








